import { colors } from '../constants/colors';
import {
  BANK_CREDIT_PENDING,
  BANK_CREDIT_ACCEPTED,
  BANK_CREDIT_REJECTED,
  BANK_CREDIT_WAITING,
  BANK_CREDIT_REGISTERED,
} from '../constants/bankCreditStatuses';

const sum = (banks, ids) => ids.reduce((total, id) => total + (banks?.[id] || 0), 0);

/**
 * Как банки ответили по сделке, одной строкой для таблицы сделок лида:
 * [{ text: '1 одобрено', color }, { text: '2 отказано', color }, ...].
 * banks — { statusId: количество заявок } из карточки лида (deals[].banks).
 * Отменённые заявки не считаем: менеджеру они ничего не говорят.
 */
const leadBankSummary = (banks) => {
  const approved = sum(banks, [BANK_CREDIT_ACCEPTED]);
  const rejected = sum(banks, [BANK_CREDIT_REJECTED]);
  const waiting = sum(banks, [BANK_CREDIT_PENDING, BANK_CREDIT_WAITING, BANK_CREDIT_REGISTERED]);

  const parts = [];
  if (approved) parts.push({ text: `${approved} одобрено`, color: colors.green });
  if (waiting) parts.push({ text: `${waiting} ждём`, color: colors.dimGray });
  if (rejected) parts.push({ text: `${rejected} отказано`, color: colors.red });
  return parts;
};

export default leadBankSummary;
